module.exports = __webpack_public_path__ + "static/img/3-9.59a9e0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-9.jpg
// module id = chhn
// module chunks = 1